// Screen 7: Knowledge Graph — premium interactive constellation.
// Zoom + pan, refined monochrome accent palette, subtle 3D perspective.

// ──────────────────────────────────────────────────────────────────
// Data
// ──────────────────────────────────────────────────────────────────

const GRAPH_NODES = [
  // center
  { id: 'gsdit',    kind: 'paper',   label: 'GS-DiT',                  year: 26, venue: 'CVPR', size: 28, depth: 0,  center: true, citations: 142 },

  // first ring — strong direct neighbors
  { id: '3dgs',     kind: 'paper',   label: '3D Gaussian Splatting',   year: 23, venue: 'SIGGRAPH', size: 18, depth: 1, citations: 4180 },
  { id: 'd3dgs',    kind: 'paper',   label: 'Deformable-3DGS',         year: 24, venue: 'CVPR',     size: 16, depth: 1, citations: 612 },
  { id: 'dit',      kind: 'paper',   label: 'DiT',                     year: 23, venue: 'ICCV',     size: 14, depth: 1, citations: 891 },
  { id: 'cache',    kind: 'paper',   label: '4DGS-Cache',              year: 26, venue: 'SIGGRAPH', size: 16, depth: 1, citations: 38 },
  { id: 'park',     kind: 'paper',   label: 'Park 24',                 year: 24, venue: 'CVPR',     size: 14, depth: 1, citations: 240 },
  { id: 'sv3dgs',   kind: 'paper',   label: 'SV-3DGS',                 year: 25, venue: 'ICCV',     size: 12, depth: 1, citations: 96 },
  { id: 'edit',     kind: 'paper',   label: 'GS-Edit',                 year: 26, venue: 'ECCV',     size: 12, depth: 1, citations: 24 },

  // concepts
  { id: 'c-def',    kind: 'concept', label: 'deformation field',       size: 10, depth: 1 },
  { id: 'c-gs',     kind: 'concept', label: 'gaussian splat',           size: 10, depth: 1 },
  { id: 'c-dit',    kind: 'concept', label: 'diffusion transformer',    size: 9,  depth: 1 },
  { id: 'c-sparse', kind: 'concept', label: 'sparse-view',              size: 9,  depth: 2 },
  { id: 'c-cache',  kind: 'concept', label: 'vq-cache',                 size: 8,  depth: 1 },

  // datasets
  { id: 'd-dnerf',   kind: 'dataset', label: 'D-NeRF',     size: 11, depth: 1 },
  { id: 'd-hyper',   kind: 'dataset', label: 'HyperNeRF',  size: 9,  depth: 2 },
  { id: 'd-dl3dv',   kind: 'dataset', label: 'DL3DV-10K',  size: 9,  depth: 2 },

  // authors
  { id: 'a-mild',  kind: 'author', label: 'Mildenhall', size: 10, depth: 1, followed: true },
  { id: 'a-park',  kind: 'author', label: 'Park K.',    size: 10, depth: 2 },
  { id: 'a-tancik',kind: 'author', label: 'Tancik',     size: 11, depth: 1 },

  // projects
  { id: 'p-rack',  kind: 'project', label: 'Server-rack twin',  size: 11, depth: 1 },
  { id: 'p-4d',    kind: 'project', label: '4D reconstruction', size: 10, depth: 1 },

  // outer ring — distant
  { id: 'kplanes', kind: 'paper', label: 'K-Planes',     year: 23, venue: 'CVPR',   size: 11, depth: 3, citations: 540 },
  { id: 'stop',    kind: 'paper', label: 'Stop Citing PSNR', year: 26, venue: 'arXiv', size: 10, depth: 3, citations: 6 },
  { id: 'tinv',    kind: 'paper', label: 'TiNeuVox',     year: 23, venue: 'ICCV',   size: 9,  depth: 3, citations: 420 },
  { id: 'sfm',     kind: 'paper', label: 'SfM in 90s',   year: 26, venue: 'CVPR',   size: 10, depth: 3, citations: 18 },
  { id: 'mvla',    kind: 'paper', label: 'OpenVLA-2',    year: 26, venue: 'CoRL',   size: 12, depth: 3, citations: 88 },
  { id: 'rfm',     kind: 'paper', label: 'RoboFM-13B',   year: 25, venue: 'NeurIPS',size: 12, depth: 3, citations: 66 },
];

const GRAPH_EDGES = [
  ['gsdit', '3dgs',   'cites',   0.95],
  ['gsdit', 'd3dgs',  'cites',   0.92],
  ['gsdit', 'dit',    'cites',   0.84],
  ['gsdit', 'park',   'family',  0.85],
  ['gsdit', 'sv3dgs', 'family',  0.65],
  ['cache', 'gsdit',  'improves',0.92],
  ['edit',  'gsdit',  'cites',   0.70],
  ['stop',  'gsdit',  'cites',   0.55],
  ['gsdit', 'c-def',  'concept', 0.90],
  ['gsdit', 'c-gs',   'concept', 0.85],
  ['gsdit', 'c-dit',  'concept', 0.90],
  ['gsdit', 'c-cache','concept', 0.95],
  ['d3dgs', 'c-def',  'concept', 0.90],
  ['park',  'c-def',  'concept', 0.95],
  ['3dgs',  'c-gs',   'concept', 0.95],
  ['cache', 'c-cache','concept', 0.90],
  ['cache', 'c-gs',   'concept', 0.80],
  ['dit',   'c-dit',  'concept', 0.95],
  ['sv3dgs','c-sparse','concept',0.95],
  ['sv3dgs','c-gs',   'concept', 0.85],
  ['gsdit', 'd-dnerf', 'dataset', 0.95],
  ['cache', 'd-dnerf', 'dataset', 0.85],
  ['d3dgs', 'd-dnerf', 'dataset', 0.85],
  ['gsdit', 'd-hyper', 'dataset', 0.70],
  ['sv3dgs','d-dl3dv', 'dataset', 0.90],
  ['gsdit', 'a-tancik','author',  0.95],
  ['gsdit', 'a-mild',  'author',  0.85],
  ['d3dgs', 'a-park',  'author',  0.95],
  ['3dgs',  'a-mild',  'author',  0.75],
  ['park',  'a-park',  'author',  0.95],
  ['p-rack', 'gsdit',  'project', 0.90],
  ['p-rack', 'sv3dgs', 'project', 0.70],
  ['p-rack', 'sfm',    'project', 0.65],
  ['p-4d',   'gsdit',  'project', 0.85],
  ['p-4d',   'park',   'project', 0.75],
  ['p-4d',   'cache',  'project', 0.80],
  ['kplanes', '3dgs',  'family',  0.55],
  ['kplanes', 'c-def', 'concept', 0.65],
  ['tinv',    'c-def', 'concept', 0.55],
  ['stop',    'cache', 'cites',   0.40],
  ['mvla',    'rfm',   'compares',0.60],
  ['sfm',     '3dgs',  'family',  0.45],
];

// ──────────────────────────────────────────────────────────────────
// Refined monochrome accent palette — indigo / violet / pale cyan.
// All edges share the indigo base; only weight / dash / flow differ.
// ──────────────────────────────────────────────────────────────────

const EDGE_STYLE = {
  cites:    { tone: 'indigo', flow: true,  width: 1.3, dash: null },
  improves: { tone: 'violet', flow: true,  width: 1.7, dash: null },
  family:   { tone: 'muted',  flow: false, width: 1.0, dash: '4 4' },
  concept:  { tone: 'cyan',   flow: false, width: 0.7, dash: '1 4' },
  dataset:  { tone: 'muted',  flow: false, width: 0.9, dash: '2 5' },
  author:   { tone: 'muted',  flow: false, width: 0.7, dash: '1 5' },
  project:  { tone: 'white',  flow: true,  width: 1.3, dash: null },
  compares: { tone: 'cyan',   flow: false, width: 0.9, dash: '6 4' },
};

const TONE_COLOR = {
  indigo: '#8896FF',
  violet: '#B49BFF',
  cyan:   '#7EC4E8',
  muted:  '#5D6678',
  white:  '#E6E8F0',
};

// ──────────────────────────────────────────────────────────────────
// Force simulation hook
// ──────────────────────────────────────────────────────────────────

function useForceSim(nodes, edges, width, height) {
  const simRef = React.useRef({ nodes: null, edges: null, draggingId: null });
  const [, force] = React.useReducer(x => x + 1, 0);
  const rafRef = React.useRef(null);
  const tickRef = React.useRef(0);

  React.useEffect(() => {
    const init = nodes.map((n, i) => {
      const angle = (i / nodes.length) * Math.PI * 2;
      const r = n.center ? 0 : (n.depth >= 3 ? 280 : n.depth === 2 ? 200 : 150);
      return {
        ...n,
        x: width / 2 + Math.cos(angle) * r + (Math.random() - 0.5) * 60,
        y: height / 2 + Math.sin(angle) * r + (Math.random() - 0.5) * 60,
        vx: 0, vy: 0,
      };
    });
    simRef.current.nodes = init;
    simRef.current.edges = edges;
    tickRef.current = 0;
    force();
  }, [nodes, edges, width, height]);

  React.useEffect(() => {
    let cancelled = false;
    const tick = () => {
      if (cancelled) return;
      const sim = simRef.current;
      if (!sim.nodes) { rafRef.current = requestAnimationFrame(tick); return; }
      const N = sim.nodes, E = sim.edges;
      const cx = width / 2, cy = height / 2;

      for (let i = 0; i < N.length; i++) {
        const a = N[i];
        if (a.id === sim.draggingId) continue;
        for (let j = i + 1; j < N.length; j++) {
          const b = N[j];
          let dx = a.x - b.x, dy = a.y - b.y;
          let d2 = dx * dx + dy * dy + 0.01;
          const d = Math.sqrt(d2);
          const minD = (a.size + b.size) * 1.2 + 30;
          const f = (minD * minD) / d2 * 0.06;
          dx /= d; dy /= d;
          a.vx += dx * f; a.vy += dy * f;
          if (b.id !== sim.draggingId) { b.vx -= dx * f; b.vy -= dy * f; }
        }
      }

      for (const [aId, bId, , w] of E) {
        const a = N.find(n => n.id === aId);
        const b = N.find(n => n.id === bId);
        if (!a || !b) continue;
        const dx = b.x - a.x, dy = b.y - a.y;
        const d = Math.sqrt(dx * dx + dy * dy) + 0.01;
        const rest = (a.center || b.center) ? 130 : 110 + (1 - w) * 80;
        const k = 0.012 * (0.4 + w);
        const f = (d - rest) * k;
        const ux = dx / d, uy = dy / d;
        if (a.id !== sim.draggingId) { a.vx += ux * f; a.vy += uy * f; }
        if (b.id !== sim.draggingId) { b.vx -= ux * f; b.vy -= uy * f; }
      }

      for (const n of N) {
        if (n.id === sim.draggingId) continue;
        if (n.center) { n.x = cx; n.y = cy; n.vx = 0; n.vy = 0; continue; }
        const g = n.depth >= 3 ? 0.0015 : 0.004;
        n.vx += (cx - n.x) * g;
        n.vy += (cy - n.y) * g;
      }

      const damp = 0.78;
      for (const n of N) {
        if (n.id === sim.draggingId) { n.vx = 0; n.vy = 0; continue; }
        n.vx *= damp; n.vy *= damp;
        n.x += n.vx; n.y += n.vy;
      }

      tickRef.current++;
      if (tickRef.current < 240 || tickRef.current % 2 === 0) force();
      rafRef.current = requestAnimationFrame(tick);
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => { cancelled = true; if (rafRef.current) cancelAnimationFrame(rafRef.current); };
  }, [width, height]);

  const setDragging = (id) => { simRef.current.draggingId = id; };
  const moveDragged = (x, y) => {
    if (!simRef.current.draggingId || !simRef.current.nodes) return;
    const n = simRef.current.nodes.find(n => n.id === simRef.current.draggingId);
    if (n) { n.x = x; n.y = y; }
    force();
  };
  const reheat = () => { tickRef.current = 0; };

  return { nodes: simRef.current.nodes || [], setDragging, moveDragged, reheat };
}

// ──────────────────────────────────────────────────────────────────
// Main graph component
// ──────────────────────────────────────────────────────────────────

function KnowledgeGraph({ onSelectNode, selectedId, hoveredId, setHoveredId, edgeFilter, zoom, setZoom, pan, setPan }) {
  const containerRef = React.useRef(null);
  const stageRef = React.useRef(null);
  const [size, setSize] = React.useState({ w: 960, h: 720 });
  const [tilt, setTilt] = React.useState({ x: 0, y: 0 });

  React.useEffect(() => {
    const update = () => {
      if (!containerRef.current) return;
      const r = containerRef.current.getBoundingClientRect();
      setSize({ w: Math.max(600, r.width), h: Math.max(400, r.height) });
    };
    update();
    const ro = new ResizeObserver(update);
    if (containerRef.current) ro.observe(containerRef.current);
    return () => ro.disconnect();
  }, []);

  const { nodes, setDragging, moveDragged, reheat } = useForceSim(GRAPH_NODES, GRAPH_EDGES, size.w, size.h);

  const focusId = hoveredId || selectedId;
  const connectedIds = React.useMemo(() => {
    if (!focusId) return null;
    const set = new Set([focusId]);
    for (const [a, b] of GRAPH_EDGES) {
      if (a === focusId) set.add(b);
      if (b === focusId) set.add(a);
    }
    return set;
  }, [focusId]);

  // Wheel zoom — zoom toward cursor
  const onWheel = (e) => {
    e.preventDefault();
    const r = stageRef.current.getBoundingClientRect();
    const mx = e.clientX - r.left, my = e.clientY - r.top;
    const delta = -e.deltaY * 0.0015;
    const next = Math.min(2.4, Math.max(0.4, zoom * (1 + delta)));
    // Zoom about cursor: pan adjustment so the world point under cursor stays fixed
    const worldX = (mx - pan.x) / zoom;
    const worldY = (my - pan.y) / zoom;
    setPan({ x: mx - worldX * next, y: my - worldY * next });
    setZoom(next);
  };

  // Pan on empty drag
  const panStartRef = React.useRef(null);
  const onStageDown = (e) => {
    if (e.target.closest('[data-kg-node]')) return;
    panStartRef.current = { x: e.clientX - pan.x, y: e.clientY - pan.y };
  };
  const onStageMove = (e) => {
    if (panStartRef.current) {
      setPan({ x: e.clientX - panStartRef.current.x, y: e.clientY - panStartRef.current.y });
    }
    // subtle 3D tilt by mouse
    if (stageRef.current) {
      const r = stageRef.current.getBoundingClientRect();
      const nx = ((e.clientX - r.left) / r.width  - 0.5) * 2;
      const ny = ((e.clientY - r.top)  / r.height - 0.5) * 2;
      setTilt({ x: -ny * 4, y: nx * 5 });
    }
  };
  const onStageUp = () => { panStartRef.current = null; };

  // Drag node
  const onNodeMouseDown = (e, id) => {
    e.stopPropagation();
    e.preventDefault();
    setDragging(id);
    const svg = e.currentTarget.ownerSVGElement;
    const onMove = (ev) => {
      const pt = svg.createSVGPoint();
      pt.x = ev.clientX; pt.y = ev.clientY;
      const p = pt.matrixTransform(svg.getScreenCTM().inverse());
      moveDragged(p.x, p.y);
    };
    const onUp = () => {
      setDragging(null); reheat();
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('mouseup', onUp);
    };
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onUp);
  };

  const visibleEdges = GRAPH_EDGES.filter(([, , type]) => edgeFilter[type] !== false);

  const curvedPath = (a, b) => {
    const dx = b.x - a.x, dy = b.y - a.y;
    const dist = Math.sqrt(dx * dx + dy * dy);
    const sag = Math.min(40, dist * 0.18);
    const mx = (a.x + b.x) / 2 + (-dy / dist) * sag;
    const my = (a.y + b.y) / 2 + (dx / dist) * sag;
    return `M ${a.x} ${a.y} Q ${mx} ${my} ${b.x} ${b.y}`;
  };

  // Sort nodes back-to-front by depth for layered look
  const sortedNodes = [...nodes].sort((a, b) => (b.depth || 0) - (a.depth || 0));

  return (
    <div className="pp-kg-stage"
      ref={(el) => { containerRef.current = el; stageRef.current = el; }}
      onWheel={onWheel}
      onMouseDown={onStageDown}
      onMouseMove={onStageMove}
      onMouseUp={onStageUp}
      onMouseLeave={onStageUp}>

      <div className="pp-kg-nebula"/>
      <div className="pp-kg-stars"/>

      {/* 3D perspective wrapper */}
      <div className="pp-kg-3d" style={{
        transform: `perspective(1400px) rotateX(${tilt.x}deg) rotateY(${tilt.y}deg)`,
      }}>
        <svg className="pp-kg-svg" viewBox={`0 0 ${size.w} ${size.h}`} preserveAspectRatio="xMidYMid meet">
          <defs>
            {/* center sphere — chrome/silver feel */}
            <radialGradient id="kgCenter" cx="38%" cy="32%" r="75%">
              <stop offset="0%"   stopColor="#F2F4FA" stopOpacity="1"/>
              <stop offset="35%"  stopColor="#A8B3FF" stopOpacity="1"/>
              <stop offset="100%" stopColor="#2C3678" stopOpacity="1"/>
            </radialGradient>
            <radialGradient id="kgPaper" cx="38%" cy="32%" r="75%">
              <stop offset="0%"   stopColor="#D4DAFF" stopOpacity="1"/>
              <stop offset="55%"  stopColor="#8896FF" stopOpacity="1"/>
              <stop offset="100%" stopColor="#252E6B" stopOpacity="1"/>
            </radialGradient>
            <radialGradient id="kgPaperFaded" cx="38%" cy="32%" r="75%">
              <stop offset="0%"   stopColor="#9AA3DA" stopOpacity="0.9"/>
              <stop offset="100%" stopColor="#1E2552" stopOpacity="0.9"/>
            </radialGradient>
            <radialGradient id="kgDataset" cx="38%" cy="32%" r="75%">
              <stop offset="0%"   stopColor="#BACCDD" stopOpacity="1"/>
              <stop offset="100%" stopColor="#2A3A56" stopOpacity="1"/>
            </radialGradient>
            <radialGradient id="kgAuthor" cx="38%" cy="32%" r="75%">
              <stop offset="0%"   stopColor="#D6CCEA" stopOpacity="1"/>
              <stop offset="100%" stopColor="#3F345B" stopOpacity="1"/>
            </radialGradient>

            <filter id="kgGlow" x="-100%" y="-100%" width="300%" height="300%">
              <feGaussianBlur stdDeviation="4" result="blur"/>
              <feMerge><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge>
            </filter>
            <filter id="kgHalo" x="-200%" y="-200%" width="500%" height="500%">
              <feGaussianBlur stdDeviation="12"/>
            </filter>
            <filter id="kgShadow" x="-50%" y="-50%" width="200%" height="200%">
              <feGaussianBlur stdDeviation="3" in="SourceAlpha"/>
              <feOffset dx="0" dy="3" result="offsetblur"/>
              <feComponentTransfer><feFuncA type="linear" slope="0.4"/></feComponentTransfer>
              <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
            </filter>

            <pattern id="kgDots" width="36" height="36" patternUnits="userSpaceOnUse">
              <circle cx="1.5" cy="1.5" r="0.7" fill="rgba(255,255,255,0.05)"/>
            </pattern>
          </defs>

          {/* Background grid */}
          <rect width={size.w} height={size.h} fill="url(#kgDots)"/>

          {/* Pan/zoom transform group */}
          <g transform={`translate(${pan.x},${pan.y}) scale(${zoom})`}>

            {/* orbit rings around center */}
            {nodes.length > 0 && (() => {
              const c = nodes.find(n => n.center);
              if (!c) return null;
              return (
                <g opacity="0.6" style={{ pointerEvents: 'none' }}>
                  {[120, 230, 340].map((r, i) => (
                    <ellipse key={r} cx={c.x} cy={c.y} rx={r} ry={r * 0.92} fill="none"
                      stroke="rgba(136,150,255,0.10)" strokeWidth="1"
                      strokeDasharray={i === 0 ? '2 6' : i === 1 ? '2 10' : '1 12'}/>
                  ))}
                  {/* Inner glow disc */}
                  <circle cx={c.x} cy={c.y} r="60" fill="rgba(136,150,255,0.08)" filter="url(#kgHalo)"/>
                </g>
              );
            })()}

            {/* edges */}
            <g>
              {visibleEdges.map(([aId, bId, type, w], i) => {
                const a = nodes.find(n => n.id === aId);
                const b = nodes.find(n => n.id === bId);
                if (!a || !b) return null;
                const style = EDGE_STYLE[type] || EDGE_STYLE.cites;
                const color = TONE_COLOR[style.tone];
                const involves = focusId && (a.id === focusId || b.id === focusId);
                const otherFocused = focusId && !involves;
                const op = (0.10 + w * 0.45) * (otherFocused ? 0.18 : involves ? 1.6 : 1);
                const strokeW = style.width * (involves ? 1.8 : 1);
                return (
                  <g key={i} className={'pp-kg-edge' + (involves ? ' is-focused' : '')}>
                    <path
                      d={curvedPath(a, b)}
                      fill="none"
                      stroke={color}
                      strokeWidth={strokeW}
                      strokeOpacity={Math.min(0.85, op)}
                      strokeDasharray={style.dash || (style.flow ? '6 6' : null)}
                      strokeLinecap="round"
                      className={style.flow ? 'pp-kg-edge-flow' : ''}
                      style={style.flow ? { animationDuration: `${2 + (1 - w) * 4}s` } : null}
                    />
                  </g>
                );
              })}
            </g>

            {/* nodes (back-to-front) */}
            <g>
              {sortedNodes.map(n => {
                const dim = connectedIds && !connectedIds.has(n.id);
                const focused = focusId === n.id;
                const selected = selectedId === n.id;
                const depthFactor = 1 - (n.depth || 0) * 0.12; // back nodes a touch smaller-feeling
                const isPaper   = n.kind === 'paper';
                const isConcept = n.kind === 'concept';
                const isDataset = n.kind === 'dataset';
                const isAuthor  = n.kind === 'author';
                const isProject = n.kind === 'project';

                let fill = '#0B0D12';
                if (n.center) fill = 'url(#kgCenter)';
                else if (isPaper)   fill = n.depth >= 3 ? 'url(#kgPaperFaded)' : 'url(#kgPaper)';
                else if (isDataset) fill = 'url(#kgDataset)';
                else if (isAuthor)  fill = 'url(#kgAuthor)';

                const sphereR = n.size;
                const haloColor =
                  isConcept ? 'rgba(126,196,232,0.40)' :
                  isProject ? 'rgba(230,232,240,0.40)' :
                  isAuthor  ? 'rgba(180,155,255,0.40)' :
                  isDataset ? 'rgba(186,204,221,0.35)' :
                  'rgba(136,150,255,0.55)';

                return (
                  <g key={n.id}
                    transform={`translate(${n.x},${n.y})`}
                    data-kg-node="1"
                    onClick={(e) => { e.stopPropagation(); onSelectNode(n.id); }}
                    onMouseEnter={() => setHoveredId(n.id)}
                    onMouseLeave={() => setHoveredId(null)}
                    onMouseDown={(e) => onNodeMouseDown(e, n.id)}
                    style={{ cursor: 'grab', opacity: dim ? 0.22 : (n.depth >= 3 ? 0.78 : 1), transition: 'opacity .25s' }}
                    className={'pp-kg-node-g' + (focused ? ' is-focused' : '') + (selected ? ' is-selected' : '')}>

                    {/* drop shadow ellipse below — sells 3D placement */}
                    {!isProject && !isConcept && (
                      <ellipse cy={sphereR + 4} rx={sphereR * 0.65} ry={sphereR * 0.18}
                        fill="rgba(0,0,0,0.45)" filter="url(#kgGlow)" opacity="0.6"/>
                    )}

                    {/* selection ring */}
                    {selected && (
                      <circle r={sphereR + 14} fill="none"
                        stroke="rgba(230,232,240,0.55)" strokeWidth="1" strokeDasharray="2 3"
                        className="pp-kg-selring"/>
                    )}

                    {/* outer halo for important nodes */}
                    {(n.center || focused || selected || n.followed) && (
                      <circle r={sphereR * 2.2}
                        fill={haloColor}
                        filter="url(#kgHalo)"
                        opacity={n.center ? 0.85 : 0.55}/>
                    )}
                    {isPaper && n.depth < 3 && !n.center && (
                      <circle r={sphereR * 1.5} fill={haloColor} opacity={0.16} filter="url(#kgGlow)"/>
                    )}

                    {/* concept dashed ring */}
                    {isConcept && (
                      <>
                        <circle r={sphereR} fill="rgba(126,196,232,0.05)" stroke="#7EC4E8" strokeWidth="1" strokeDasharray="2 2" opacity="0.85"/>
                        <circle r={sphereR + 4} fill="none" stroke="#7EC4E8" strokeOpacity="0.18" strokeWidth="1"/>
                      </>
                    )}

                    {/* project square */}
                    {isProject && (
                      <>
                        <rect x={-sphereR} y={-sphereR} width={sphereR * 2} height={sphereR * 2}
                          rx="3" fill="rgba(230,232,240,0.04)" stroke="rgba(230,232,240,0.6)"
                          strokeWidth="1.2" strokeDasharray="3 2"/>
                        <rect x={-sphereR + 2} y={-sphereR + 2} width={sphereR * 2 - 4} height={sphereR * 2 - 4}
                          rx="2" fill="none" stroke="rgba(230,232,240,0.18)" strokeWidth="0.6"/>
                      </>
                    )}

                    {/* core sphere (paper/dataset/author) */}
                    {(isPaper || isDataset || isAuthor) && (
                      <>
                        <circle r={sphereR} fill={fill} stroke="rgba(7,8,11,0.7)" strokeWidth="1.5" filter="url(#kgShadow)"/>
                        {/* specular highlight — fakes spherical 3D */}
                        <ellipse cx={-sphereR * 0.28} cy={-sphereR * 0.34}
                          rx={sphereR * 0.42} ry={sphereR * 0.32}
                          fill="rgba(255,255,255,0.45)" filter="url(#kgGlow)" opacity="0.65"
                          style={{ pointerEvents: 'none' }}/>
                        {/* rim light */}
                        <circle r={sphereR} fill="none" stroke="rgba(255,255,255,0.10)" strokeWidth="0.6"
                          style={{ pointerEvents: 'none' }}/>
                      </>
                    )}

                    {/* inner glyph */}
                    {isPaper && !n.center && (
                      <text textAnchor="middle" dominantBaseline="middle"
                        fontFamily="Geist Mono, monospace" fontSize={Math.min(10, sphereR * 0.55)}
                        fill="rgba(255,255,255,0.85)" fontWeight={500}
                        style={{ pointerEvents: 'none' }}>’{n.year}</text>
                    )}
                    {n.center && (
                      <g style={{ pointerEvents: 'none' }}>
                        <text textAnchor="middle" dominantBaseline="middle" dy="-3"
                          fontFamily="Instrument Serif, serif" fontSize="14"
                          fill="#fff" fontWeight={500}>{n.label}</text>
                        <text textAnchor="middle" dominantBaseline="middle" dy="11"
                          fontFamily="Geist Mono, monospace" fontSize="8.5"
                          fill="rgba(255,255,255,0.65)" letterSpacing="0.08em">CVPR ’26</text>
                      </g>
                    )}
                    {isAuthor && (
                      <text textAnchor="middle" dominantBaseline="middle"
                        fontFamily="Nunito, sans-serif" fontSize={Math.min(11, sphereR * 0.65)}
                        fill="#fff" fontWeight={600}
                        style={{ pointerEvents: 'none' }}>{n.label[0]}</text>
                    )}
                    {isDataset && (
                      <g style={{ pointerEvents: 'none' }}>
                        <ellipse cx="0" cy="-3" rx={sphereR * 0.55} ry="1.6" fill="rgba(255,255,255,0.30)"/>
                        <ellipse cx="0" cy="0"  rx={sphereR * 0.55} ry="1.6" fill="rgba(255,255,255,0.30)"/>
                        <ellipse cx="0" cy="3"  rx={sphereR * 0.55} ry="1.6" fill="rgba(255,255,255,0.30)"/>
                      </g>
                    )}
                    {isProject && (
                      <text textAnchor="middle" dominantBaseline="middle"
                        fontFamily="Geist Mono, monospace" fontSize="9"
                        fill="rgba(230,232,240,0.85)" letterSpacing="0.1em"
                        style={{ pointerEvents: 'none' }}>PRJ</text>
                    )}

                    {/* label */}
                    {!n.center && (
                      <text textAnchor="middle"
                        y={sphereR + 14}
                        fontFamily={isConcept ? 'Instrument Serif, serif' : 'Nunito, sans-serif'}
                        fontStyle={isConcept ? 'italic' : 'normal'}
                        fontSize={sphereR > 12 ? 12 : 10.5}
                        fontWeight={n.followed || focused ? 600 : 400}
                        fill={dim ? 'rgba(200,205,219,0.50)' : focused ? '#fff' : 'rgba(200,205,219,0.92)'}
                        style={{ pointerEvents: 'none' }}>
                        {n.label}
                      </text>
                    )}
                    {(isPaper && !n.center) && (
                      <text textAnchor="middle"
                        y={sphereR + 26}
                        fontFamily="Geist Mono, monospace" fontSize="8.5"
                        fill={dim ? 'rgba(93,102,120,0.5)' : 'rgba(136,150,255,0.85)'}
                        style={{ pointerEvents: 'none', letterSpacing: '0.06em' }}>
                        {n.venue} · {n.citations} cites
                      </text>
                    )}
                    {n.followed && (
                      <g transform={`translate(${sphereR - 2},${-sphereR + 2})`} style={{ pointerEvents: 'none' }}>
                        <circle r="5" fill="#0B0D12" stroke="#B49BFF" strokeWidth="1"/>
                        <text textAnchor="middle" dominantBaseline="middle" fontSize="7" fill="#B49BFF" fontWeight={700}>★</text>
                      </g>
                    )}
                  </g>
                );
              })}
            </g>
          </g>
        </svg>
      </div>

      <MiniMap nodes={nodes} size={size} focusId={focusId} zoom={zoom} pan={pan}/>
    </div>
  );
}

// ──────────────────────────────────────────────────────────────────
// Mini-map
// ──────────────────────────────────────────────────────────────────
function MiniMap({ nodes, size, focusId, zoom, pan }) {
  const w = 140, h = 100;
  const sx = w / size.w, sy = h / size.h;
  // Viewport rect in minimap coords
  const vw = w / zoom, vh = h / zoom;
  const vx = -pan.x * sx / zoom, vy = -pan.y * sy / zoom;
  return (
    <div className="pp-kg-minimap">
      <div className="pp-kg-minimap-label mono">Overview</div>
      <svg width={w} height={h} viewBox={`0 0 ${w} ${h}`}>
        <rect width={w} height={h} fill="rgba(255,255,255,0.02)"/>
        {nodes.map(n => {
          const r = Math.max(1, n.size * sx * 0.4);
          const isF = focusId === n.id;
          const color = n.center ? '#FFF' : n.kind === 'concept' ? '#7EC4E8' : n.kind === 'author' ? '#B49BFF' : '#8896FF';
          return (
            <circle key={n.id} cx={n.x * sx} cy={n.y * sy} r={isF ? r + 1.5 : r}
              fill={color} opacity={isF ? 1 : 0.7}/>
          );
        })}
        {/* viewport indicator */}
        <rect x={Math.max(0, vx)} y={Math.max(0, vy)}
          width={Math.min(w, vw)} height={Math.min(h, vh)}
          fill="none" stroke="rgba(136,150,255,0.50)" strokeWidth="1"
          strokeDasharray="2 2"/>
      </svg>
    </div>
  );
}

// ──────────────────────────────────────────────────────────────────
// Screen
// ──────────────────────────────────────────────────────────────────

function GraphScreen() {
  const { t, lang } = useT();
  const [selectedId, setSelectedId] = React.useState('gsdit');
  const [hoveredId, setHoveredId] = React.useState(null);
  const [edgeFilter, setEdgeFilter] = React.useState({
    cites: true, improves: true, compares: true, dataset: true, family: true, author: false, concept: true, project: true,
  });
  const [view, setView] = React.useState('paper');
  const [zoom, setZoom] = React.useState(1);
  const [pan, setPan] = React.useState({ x: 0, y: 0 });

  const toggleEdge = (type) => setEdgeFilter(f => ({ ...f, [type]: !f[type] }));
  const selectedNode = GRAPH_NODES.find(n => n.id === selectedId);

  const zoomIn  = () => setZoom(z => Math.min(2.4, z * 1.2));
  const zoomOut = () => setZoom(z => Math.max(0.4, z / 1.2));
  const zoomFit = () => { setZoom(1); setPan({ x: 0, y: 0 }); };

  return (
    <div className="pp pp-screen" data-screen-label="07 Knowledge graph">
      <Sidebar active="graph"/>

      <div className="pp-main">
        <TopBar
          breadcrumbs={<Breadcrumb items={[t('crumb.workspace'), t('crumb.graph'), selectedNode?.label || 'GS-DiT']}/>}
          search="Search nodes — papers, methods, datasets, concepts…"
        />

        <div className="pp-content">
          <RailLeft id="graph-left" defaultWidth={220} min={180} max={320} className="pp-graph-left scroll">
            <div className="section-title" style={{ marginBottom: 8 }}>{t('gr.view')}</div>
            <div className="pp-graph-tabs">
              {[
                { id: 'paper',   icon: 'figure',   label: t('gr.v.paper') },
                { id: 'concept', icon: 'sparkles', label: t('gr.v.concept') },
                { id: 'dataset', icon: 'data',     label: t('gr.v.dataset') },
                { id: 'author',  icon: 'user',     label: t('gr.v.author') },
              ].map(v => (
                <button key={v.id} className={'pp-graph-tab ' + (view === v.id ? 'is-active' : '')} onClick={() => setView(v.id)}>
                  <I name={v.icon} size={11}/> {v.label}
                </button>
              ))}
            </div>

            <div className="section-title" style={{ marginTop: 18, marginBottom: 8 }}>{t('gr.edges')}</div>
            <div className="col gap-1">
              <EdgeToggle on={edgeFilter.cites}    onClick={() => toggleEdge('cites')}    color={TONE_COLOR.indigo} label={t('gr.e.cites')} count="14"/>
              <EdgeToggle on={edgeFilter.improves} onClick={() => toggleEdge('improves')} color={TONE_COLOR.violet} label={t('gr.e.improves')} count="6"/>
              <EdgeToggle on={edgeFilter.compares} onClick={() => toggleEdge('compares')} color={TONE_COLOR.cyan}   label={t('gr.e.compares')} count="9"/>
              <EdgeToggle on={edgeFilter.dataset}  onClick={() => toggleEdge('dataset')}  color={TONE_COLOR.muted}  label={t('gr.e.dataset')} count="11"/>
              <EdgeToggle on={edgeFilter.family}   onClick={() => toggleEdge('family')}   color={TONE_COLOR.muted}  label={t('gr.e.family')} count="5"/>
              <EdgeToggle on={edgeFilter.author}   onClick={() => toggleEdge('author')}   color={TONE_COLOR.muted}  label={t('gr.e.author')}/>
              <EdgeToggle on={edgeFilter.concept}  onClick={() => toggleEdge('concept')}  color={TONE_COLOR.cyan}   label={lang === 'ko' ? '개념 연결' : 'uses concept'} count="8"/>
              <EdgeToggle on={edgeFilter.project}  onClick={() => toggleEdge('project')}  color={TONE_COLOR.white}  label={t('gr.e.project')}/>
            </div>

            <div className="section-title" style={{ marginTop: 18, marginBottom: 8 }}>{lang === 'ko' ? '범례' : 'Legend'}</div>
            <div className="col gap-2" style={{ padding: '4px 8px' }}>
              <LegendSwatch kind="paper"   label={lang === 'ko' ? '논문' : 'Paper'}/>
              <LegendSwatch kind="concept" label={lang === 'ko' ? '개념' : 'Concept'}/>
              <LegendSwatch kind="dataset" label={lang === 'ko' ? '데이터셋' : 'Dataset'}/>
              <LegendSwatch kind="author"  label={lang === 'ko' ? '저자' : 'Author'}/>
              <LegendSwatch kind="project" label={lang === 'ko' ? '프로젝트' : 'Project'}/>
            </div>

            <div className="section-title" style={{ marginTop: 18, marginBottom: 8 }}>{lang === 'ko' ? '시뮬레이션' : 'Simulation'}</div>
            <div className="col gap-2" style={{ padding: '0 4px' }}>
              <button className="btn sm ghost" style={{ width: '100%', justifyContent: 'flex-start' }} onClick={zoomFit}>
                <I name="sparkles" size={11}/> {lang === 'ko' ? '레이아웃 리셋' : 'Reset view'}
              </button>
              <button className="btn sm ghost" style={{ width: '100%', justifyContent: 'flex-start' }}>
                <I name="figure" size={11}/> {lang === 'ko' ? 'PNG 내보내기' : 'Export PNG'}
              </button>
            </div>
          </RailLeft>

          <div className="pp-graph-canvas">
            <KnowledgeGraph
              onSelectNode={setSelectedId}
              selectedId={selectedId}
              hoveredId={hoveredId}
              setHoveredId={setHoveredId}
              edgeFilter={edgeFilter}
              zoom={zoom} setZoom={setZoom}
              pan={pan} setPan={setPan}
            />

            <div className="pp-kg-toolbar">
              <button className="iconbtn" title={lang === 'ko' ? '확대' : 'Zoom in'} onClick={zoomIn}>
                <I name="plus" size={14}/>
              </button>
              <span className="mono pp-kg-zoom">{Math.round(zoom * 100)}%</span>
              <button className="iconbtn" title={lang === 'ko' ? '축소' : 'Zoom out'} onClick={zoomOut}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"><path d="M5 12h14"/></svg>
              </button>
              <div style={{ width: 1, height: 14, background: 'var(--border-2)' }}/>
              <button className="iconbtn" title={lang === 'ko' ? '맞춤' : 'Fit'} onClick={zoomFit}>
                <I name="layers" size={14}/>
              </button>
              <button className="iconbtn"><I name="figure" size={14}/></button>
            </div>

            <div className="pp-kg-stats">
              <div className="pp-kg-stat">
                <span className="mono pp-kg-stat-num">{GRAPH_NODES.length}</span>
                <span className="pp-kg-stat-lbl">{lang === 'ko' ? '노드' : 'nodes'}</span>
              </div>
              <div className="pp-kg-stat">
                <span className="mono pp-kg-stat-num">{GRAPH_EDGES.length}</span>
                <span className="pp-kg-stat-lbl">{lang === 'ko' ? '엣지' : 'edges'}</span>
              </div>
              <div className="pp-kg-stat">
                <span className="mono pp-kg-stat-num">2</span>
                <span className="pp-kg-stat-lbl">{lang === 'ko' ? '홉' : 'hops'}</span>
              </div>
              <div className="pp-kg-stat">
                <span className="mono pp-kg-stat-num">{(GRAPH_EDGES.length / GRAPH_NODES.length).toFixed(1)}</span>
                <span className="pp-kg-stat-lbl">{lang === 'ko' ? '평균 차수' : 'avg deg'}</span>
              </div>
              <div className="pp-kg-stat" style={{ marginLeft: 'auto' }}>
                <span className="mono pp-kg-stat-num" style={{ color: 'var(--acc-violet)' }}>{selectedNode?.label || '—'}</span>
                <span className="pp-kg-stat-lbl">{lang === 'ko' ? '선택됨' : 'selected'}</span>
              </div>
            </div>

            <div className="pp-kg-timeline">
              <span className="mono pp-kg-time-lbl">2023</span>
              <div className="pp-kg-time-track">
                <div className="pp-kg-time-fill" style={{ width: '78%' }}/>
                <div className="pp-kg-time-knob" style={{ left: '78%' }}>
                  <span className="mono">2026</span>
                </div>
                {[23, 24, 25, 26].map(y => (
                  <div key={y} className="pp-kg-time-tick" style={{ left: `${((y - 23) / 3) * 100}%` }}/>
                ))}
              </div>
              <span className="mono pp-kg-time-lbl">2026</span>
            </div>
          </div>

          <RailRight id="graph-detail" defaultWidth={320} min={260} max={460} className="pp-graph-right scroll">
            <NodeDetailPanel node={selectedNode} setSelected={setSelectedId}/>
          </RailRight>
        </div>
      </div>
    </div>
  );
}

// ──────────────────────────────────────────────────────────────────
// Sidebar bits
// ──────────────────────────────────────────────────────────────────

function EdgeToggle({ on, color, label, count, onClick }) {
  return (
    <div className={'pp-edge-row' + (on ? ' is-on' : '')} onClick={onClick}>
      <div className="pp-edge-line" style={{ background: on ? color : 'var(--fg-4)', boxShadow: on ? `0 0 6px ${color}` : 'none' }}/>
      <span className="grow" style={{ fontSize: 11.5 }}>{label}</span>
      {count && <span className="mono" style={{ fontSize: 10, color: 'var(--fg-3)' }}>{count}</span>}
    </div>
  );
}

function LegendSwatch({ kind, label }) {
  const stops = {
    paper:   'radial-gradient(circle at 35% 30%, #D4DAFF, #252E6B)',
    concept: 'transparent',
    dataset: 'radial-gradient(circle at 35% 30%, #BACCDD, #2A3A56)',
    author:  'radial-gradient(circle at 35% 30%, #D6CCEA, #3F345B)',
    project: 'transparent',
  };
  const strokes = {
    paper: '#252E6B', concept: '#7EC4E8', dataset: '#2A3A56', author: '#3F345B', project: '#E6E8F0',
  };
  const glows = {
    paper: 'rgba(136,150,255,0.30)', concept: 'rgba(126,196,232,0.30)',
    dataset: 'rgba(186,204,221,0.20)', author: 'rgba(180,155,255,0.30)',
    project: 'rgba(230,232,240,0.20)',
  };
  return (
    <div className="row gap-2" style={{ alignItems: 'center', fontSize: 11.5, color: 'var(--fg-1)' }}>
      <div style={{
        width: 14, height: 14,
        borderRadius: kind === 'project' ? 3 : 999,
        background: stops[kind],
        border: kind === 'concept' || kind === 'project' ? `1px dashed ${strokes[kind]}` : `1px solid ${strokes[kind]}`,
        boxShadow: `0 0 8px ${glows[kind]}`,
      }}/>
      {label}
    </div>
  );
}

function NodeDetailPanel({ node, setSelected }) {
  const { t, lang } = useT();
  const nav = React.useContext(NavContext);
  if (!node) return null;

  const neighbors = GRAPH_EDGES
    .filter(([a, b]) => a === node.id || b === node.id)
    .map(([a, b, type, w]) => {
      const other = a === node.id ? b : a;
      const n = GRAPH_NODES.find(x => x.id === other);
      return { node: n, type, weight: w };
    })
    .filter(n => n.node)
    .sort((a, b) => b.weight - a.weight);

  const isPaper = node.kind === 'paper';

  return (
    <div className="col gap-3">
      <div className="row" style={{ justifyContent: 'space-between', alignItems: 'baseline' }}>
        <div className="section-title"><span className="num">{t('gr.rail.node')}</span></div>
        <RailCollapseBtn/>
      </div>

      <div className="card pp-kg-detail-hero" style={{ padding: 14 }}>
        <div className="row gap-2" style={{ alignItems: 'baseline' }}>
          <span className={'chip ' + (node.kind === 'paper' ? 'accent' : node.kind === 'concept' ? 'cyan' : 'ghost')}>
            {node.kind === 'paper' ? `${node.venue} '${node.year}` : node.kind}
          </span>
          {node.center && <span className="chip violet" style={{ height: 20 }}>center</span>}
          {node.followed && <span className="chip warn" style={{ height: 20 }}>★ {lang === 'ko' ? '팔로우' : 'followed'}</span>}
        </div>
        <div className="serif" style={{ fontSize: 20, lineHeight: 1.15, marginTop: 8 }}>{node.label}</div>
        {isPaper && (
          <div className="row gap-3 mono" style={{ marginTop: 8, fontSize: 11, color: 'var(--fg-3)' }}>
            <span>{node.citations} {lang === 'ko' ? '인용' : 'citations'}</span>
            <span>·</span>
            <span>{node.year >= 25 ? (lang === 'ko' ? '최근' : 'recent') : (lang === 'ko' ? '확립됨' : 'established')}</span>
          </div>
        )}
      </div>

      <div className="card" style={{ padding: 12 }}>
        <div className="section-title" style={{ marginBottom: 8 }}>{t('gr.rail.why')}</div>
        <div style={{ fontSize: 12, color: 'var(--fg-1)', lineHeight: 1.55 }}>
          {node.center
            ? (lang === 'ko'
              ? <>당신이 추적하는 세 가지 스레드 — deformation-field 4DGS, 실시간 렌더링, 3D용 diffusion prior — 의 교차점. <span style={{ color: 'var(--fg-0)' }}>북마크 14편</span>이 2홉 이내에서 연결됨.</>
              : <>Sits at the convergence of three threads you actively track: deformation-field 4DGS, real-time rendering, and diffusion priors for 3D. <span style={{ color: 'var(--fg-0)' }}>14 bookmarked papers</span> connect within 2 hops.</>)
            : (lang === 'ko'
              ? `중심 노드와 ${neighbors.filter(n => n.node.id === 'gsdit').length}개 직접 연결. 클러스터 내 ${neighbors.length - 1}개 관계.`
              : `${neighbors.length} relations, including ${neighbors.filter(n => n.node.center).length} direct to the center.`)
          }
        </div>
      </div>

      <div className="card" style={{ padding: 12 }}>
        <div className="section-title" style={{ marginBottom: 8 }}>{t('gr.rail.conn')}</div>
        <div className="col gap-1">
          {neighbors.slice(0, 6).map(({ node: n, type, weight }, i) => {
            const color = TONE_COLOR[(EDGE_STYLE[type] || EDGE_STYLE.cites).tone];
            return (
              <div key={i} className="pp-kg-conn-row" onClick={() => setSelected(n.id)}>
                <div className="pp-kg-conn-line" style={{ background: color, boxShadow: `0 0 4px ${color}` }}/>
                <div className="col grow" style={{ minWidth: 0 }}>
                  <div className="ellipsis" style={{ fontSize: 12, color: 'var(--fg-0)' }}>{n.label}</div>
                  <div className="ellipsis mono" style={{ fontSize: 10, color: 'var(--fg-2)' }}>{type} · {n.kind}</div>
                </div>
                <span className="mono" style={{ fontSize: 10, color }}>{weight.toFixed(2)}</span>
              </div>
            );
          })}
        </div>
      </div>

      <div className="card" style={{ padding: 12 }}>
        <div className="section-title" style={{ marginBottom: 6 }}>{t('gr.rail.ai')}</div>
        <div style={{ fontSize: 12, color: 'var(--fg-1)', lineHeight: 1.55 }}>
          {lang === 'ko'
            ? <>경로 <span className="mono" style={{ color: 'var(--acc-cyan)' }}>Deformable-3DGS → GS-DiT → 4DGS-Cache</span>는 2025–26년 실시간 동적 Gaussian splatting의 주류 계보. 이 스레드를 채택한다면 4DGS-Cache가 다음 읽기.</>
            : <>The path <span className="mono" style={{ color: 'var(--acc-cyan)' }}>Deformable-3DGS → GS-DiT → 4DGS-Cache</span> represents the dominant lineage for real-time dynamic Gaussian splatting in 2025–26. 4DGS-Cache is the next read.</>}
        </div>
      </div>

      <div className="row gap-2">
        <button className="btn sm grow" onClick={() => nav.navigate && nav.navigate('detail')}>
          <I name="external" size={12}/> {t('gr.rail.open')}
        </button>
        <button className="btn sm ghost"><I name="kanban" size={12}/></button>
        <button className="btn sm ghost"><I name="bookmark" size={12}/></button>
      </div>
    </div>
  );
}

// ──────────────────────────────────────────────────────────────────
// Styles
// ──────────────────────────────────────────────────────────────────

if (!document.getElementById('pp-graph-styles')) {
  const s = document.createElement('style');
  s.id = 'pp-graph-styles';
  s.textContent = `
  .pp-graph-left { background: var(--bg-1); padding: 18px 12px; overflow: auto; }
  .pp-graph-tabs {
    display: grid; grid-template-columns: 1fr 1fr; gap: 2px;
    padding: 3px;
    border: 1px solid var(--border-1);
    background: var(--bg-2);
    border-radius: 7px;
  }
  .pp-graph-tab {
    padding: 5px 6px;
    display: flex; align-items: center; justify-content: center; gap: 4px;
    font-size: 11px; color: var(--fg-2);
    border-radius: 5px; cursor: pointer;
  }
  .pp-graph-tab:hover { color: var(--fg-0); }
  .pp-graph-tab.is-active { background: rgba(136,150,255,0.14); color: var(--acc-indigo); box-shadow: 0 0 0 1px rgba(136,150,255,0.30); }

  .pp-edge-row {
    display: flex; align-items: center; gap: 8px;
    padding: 6px 8px; border-radius: 5px;
    color: var(--fg-2); font-size: 11.5px; cursor: pointer;
    transition: background .12s, color .12s, opacity .12s;
    opacity: 0.5;
  }
  .pp-edge-row:hover { background: rgba(255,255,255,0.025); color: var(--fg-0); opacity: 1; }
  .pp-edge-row.is-on { color: var(--fg-0); opacity: 1; }
  .pp-edge-line { width: 16px; height: 2px; border-radius: 1px; flex-shrink: 0; transition: background .12s; }

  /* Graph canvas */
  .pp-graph-canvas {
    flex: 1; min-width: 0;
    position: relative;
    background:
      radial-gradient(ellipse 90% 70% at 50% 45%, rgba(136,150,255,0.06), transparent 70%),
      radial-gradient(ellipse 60% 50% at 30% 30%, rgba(180,155,255,0.04), transparent 70%),
      var(--bg-0);
    overflow: hidden;
    display: flex;
  }
  .pp-kg-stage {
    position: relative;
    flex: 1;
    width: 100%; height: 100%;
    perspective: 1400px;
    perspective-origin: center center;
  }
  .pp-kg-3d {
    position: absolute; inset: 0;
    transform-style: preserve-3d;
    transition: transform 0.3s cubic-bezier(0.2, 0.7, 0.3, 1);
    will-change: transform;
  }

  .pp-kg-nebula {
    position: absolute; inset: -20%;
    background:
      radial-gradient(ellipse 35% 25% at 25% 30%, rgba(136,150,255,0.10), transparent 60%),
      radial-gradient(ellipse 30% 20% at 75% 65%, rgba(180,155,255,0.08), transparent 60%);
    filter: blur(40px);
    pointer-events: none;
    animation: kg-drift 60s ease-in-out infinite alternate;
  }
  @keyframes kg-drift {
    0%   { transform: translate(0, 0) rotate(0deg); }
    100% { transform: translate(-20px, 10px) rotate(2deg); }
  }
  .pp-kg-stars {
    position: absolute; inset: 0;
    background-image:
      radial-gradient(1px 1px at 15% 18%, rgba(255,255,255,0.18), transparent 100%),
      radial-gradient(1px 1px at 35% 65%, rgba(255,255,255,0.12), transparent 100%),
      radial-gradient(1.5px 1.5px at 70% 12%, rgba(180,155,255,0.22), transparent 100%),
      radial-gradient(1px 1px at 88% 78%, rgba(255,255,255,0.18), transparent 100%),
      radial-gradient(1px 1px at 50% 90%, rgba(136,150,255,0.22), transparent 100%),
      radial-gradient(1px 1px at 8% 88%, rgba(255,255,255,0.10), transparent 100%);
    background-size: 100% 100%;
    pointer-events: none;
    animation: kg-twinkle 8s ease-in-out infinite alternate;
  }
  @keyframes kg-twinkle { 0% { opacity: 0.6; } 100% { opacity: 0.95; } }

  .pp-kg-svg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    cursor: grab;
  }
  .pp-kg-svg:active { cursor: grabbing; }

  .pp-kg-edge { transition: opacity .25s; }
  .pp-kg-edge-flow { animation: kg-flow 3s linear infinite; }
  @keyframes kg-flow {
    from { stroke-dashoffset: 0; }
    to   { stroke-dashoffset: -24; }
  }
  .pp-kg-edge.is-focused .pp-kg-edge-flow { animation-duration: 1.2s !important; }

  .pp-kg-node-g { transition: filter .2s; }
  .pp-kg-node-g.is-focused { filter: brightness(1.15); }
  .pp-kg-node-g.is-selected text { text-shadow: 0 0 8px rgba(255,255,255,0.6); }
  .pp-kg-selring { animation: kg-spin 16s linear infinite; transform-origin: center; transform-box: fill-box; }
  @keyframes kg-spin { from { transform: rotate(0); } to { transform: rotate(360deg); } }

  .pp-kg-toolbar {
    position: absolute; top: 14px; right: 14px;
    display: flex; align-items: center; gap: 2px;
    padding: 4px;
    background: rgba(11,13,18,0.70); backdrop-filter: blur(12px);
    border: 1px solid var(--border-2);
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(0,0,0,0.4);
    z-index: 10;
  }
  .pp-kg-zoom {
    font-size: 10.5px; color: var(--fg-2);
    padding: 0 6px;
    min-width: 38px; text-align: center;
  }

  .pp-kg-minimap {
    position: absolute; top: 14px; left: 14px;
    padding: 6px 8px 4px;
    background: rgba(11,13,18,0.70); backdrop-filter: blur(12px);
    border: 1px solid var(--border-2);
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(0,0,0,0.4);
    z-index: 10;
  }
  .pp-kg-minimap-label {
    font-size: 9px; letter-spacing: 0.14em; text-transform: uppercase;
    color: var(--fg-3); margin-bottom: 4px; padding-left: 2px;
  }
  .pp-kg-minimap svg { display: block; border-radius: 4px; }

  .pp-kg-stats {
    position: absolute; bottom: 64px; left: 14px; right: 14px;
    display: flex; align-items: center; gap: 18px;
    padding: 8px 14px;
    background: rgba(11,13,18,0.65); backdrop-filter: blur(12px);
    border: 1px solid var(--border-1);
    border-radius: 8px;
    z-index: 10;
  }
  .pp-kg-stat { display: flex; flex-direction: column; gap: 1px; min-width: 0; }
  .pp-kg-stat-num {
    font-size: 14px; color: var(--fg-0); font-weight: 500;
    letter-spacing: -0.01em;
  }
  .pp-kg-stat-lbl {
    font-size: 9.5px; letter-spacing: 0.10em; text-transform: uppercase;
    color: var(--fg-3);
  }

  .pp-kg-timeline {
    position: absolute; bottom: 14px; left: 14px; right: 14px;
    display: flex; align-items: center; gap: 12px;
    padding: 8px 14px;
    background: rgba(11,13,18,0.65); backdrop-filter: blur(12px);
    border: 1px solid var(--border-1);
    border-radius: 8px;
    z-index: 10;
  }
  .pp-kg-time-lbl { font-size: 10px; color: var(--fg-3); }
  .pp-kg-time-track {
    flex: 1; position: relative;
    height: 4px; background: rgba(255,255,255,0.05);
    border-radius: 999px;
  }
  .pp-kg-time-fill {
    position: absolute; left: 0; top: 0; bottom: 0;
    background: linear-gradient(90deg, rgba(136,150,255,0.20), var(--acc-indigo));
    border-radius: 999px;
    box-shadow: 0 0 6px var(--acc-indigo);
  }
  .pp-kg-time-knob {
    position: absolute; top: 50%;
    transform: translate(-50%, -50%);
    display: flex; flex-direction: column; align-items: center;
  }
  .pp-kg-time-knob::before {
    content: '';
    width: 14px; height: 14px; border-radius: 999px;
    background: #fff;
    box-shadow: 0 0 0 2px var(--bg-0), 0 0 0 3px var(--acc-indigo), 0 0 16px var(--acc-indigo);
    cursor: grab;
  }
  .pp-kg-time-knob span {
    position: absolute; top: -22px;
    font-size: 10px; color: var(--acc-indigo);
    font-weight: 500;
  }
  .pp-kg-time-tick {
    position: absolute; top: -3px; bottom: -3px;
    width: 1px; background: rgba(255,255,255,0.20);
  }

  .pp-kg-detail-hero {
    background: linear-gradient(180deg, rgba(136,150,255,0.06), transparent 60%);
    border-color: rgba(136,150,255,0.20);
  }
  .pp-graph-right { background: var(--bg-1); padding: 18px; overflow: auto; }
  .pp-kg-conn-row {
    display: flex; align-items: center; gap: 8px;
    padding: 6px 4px;
    border-radius: 5px;
    cursor: pointer;
    transition: background .12s;
  }
  .pp-kg-conn-row:hover { background: rgba(255,255,255,0.025); }
  .pp-kg-conn-line { width: 12px; height: 2px; border-radius: 1px; flex-shrink: 0; }
  `;
  document.head.appendChild(s);
}

export { GraphScreen };
